import { BlocksIconEngine } from 'blocks-nextjs/blocks-web-components/components/icon/icons/engine';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconEngine = createComponent({ react: React, tagName: 'cat-icon-engine', elementClass: BlocksIconEngine });
